const translations = {
  "en": {
    "a one-time free": "a one-time free",
    "Activating live tracking is Pro — start whenever you're ready.": "Activating live tracking is Pro — start whenever you're ready.",
    "Adapts as your life and goals change": "Adapts as your life and goals change",
    "Before you go": "Before you go",
    "Build my plan free": "Build my plan free",
    "Built around your goals — yours to keep": "Built around your goals — yours to keep",
    "Ed picked you for": "Ed picked you for",
    "Ed picked you for a one-time free plan setup.": "Ed picked you for a one-time free plan setup.",
    "Get a heads-up when something drifts off track": "Get a heads-up when something drifts off track",
    "Lucky you": "Lucky you",
    "map your full money plan in 2 minutes": "Map your full money plan in 2 minutes",
    "plan setup.": "plan setup.",
    "See your full plan — all 5 moves": "See your full plan — all 5 moves",
    "Take your plan, free.": "Take your plan, free.",
    "Unlock for free": "Unlock for free",
    "Your real numbers, mapped in 2 minutes": "Your real numbers, mapped in 2 minutes"
  },
  "zh-tw": {
    "a one-time free": "一次性免費",
    "Activating live tracking is Pro — start whenever you're ready.": "啟用即時追蹤為 Pro 功能 — 你隨時可開始使用。",
    "Adapts as your life and goals change": "隨著你的生活與目標改變而調整",
    "Before you go": "離開前",
    "Build my plan free": "免費建立你的計畫",
    "Built around your goals — yours to keep": "以你的目標為核心設計 — 成果由你掌握",
    "Ed picked you for": "Ed 選了你來",
    "Ed picked you for a one-time free plan setup.": "Ed 已為你選定一次性免費方案。",
    "Get a heads-up when something drifts off track": "當某項事項偏離正軌時，立即收到提醒",
    "Lucky you": "幸運的你",
    "map your full money plan in 2 minutes": "在 2 分鐘內規劃你的完整財務計畫",
    "plan setup.": "計畫設定。",
    "See your full plan — all 5 moves": "查看你的完整計畫 — 共 5 項操作",
    "Take your plan, free.": "免費取得你的計畫",
    "Unlock for free": "免費解鎖",
    "Your real numbers, mapped in 2 minutes": "兩分鐘為你梳理實際數據"
  }
};

export default translations;
